import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_REVIEW_SERVICE_PLAN_BY_CLINICIAN')